export default "__VITE_ASSET__DEhRuVdk__"